export function getDataLayer() {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}
